import {useCallback, useEffect, useRef} from "react";

export default function useTimer(callback, delay) {
    const countDown = useRef();  // instance of a timer

    const startTimer = useCallback(() => {
        countDown.current = setTimeout(callback, delay);
    }, [delay]); // eslint-disable-line react-hooks/exhaustive-deps

    const restartTimer = useCallback(() => {
        clearTimeout(countDown.current);
        countDown.current = setTimeout(callback, delay);
    }, [delay]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(
        () => {
            return () => {
                if (countDown.current) {
                    clearTimeout(countDown.current);
                }
            }
        },
        []
    )

    return [startTimer, restartTimer]
}